import React, { useState } from 'react'
import styles from './PlannerOnboardingModal.scss'
import blueTheme from 'common/styleguide/ModalOverlay/blueHeaderModalTheme.scss'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'
import { Map } from 'immutable'
import { introText } from 'lib/styleguide/base.scss'
import fetchJSON from 'lib/fetchJSON'
import querystring from 'querystring'
import { defineMessages, FormattedMessage as T } from 'react-intl'
import { useFormatMessage, commonCTAs, Msg } from 'lib/localization'
import { tips, titles, descriptions, descriptionsValues } from './tips'
import cx from 'classnames'

const preferences = Map((window.rwgps && window.rwgps.config && window.rwgps.config.currentUser && window.rwgps.config.currentUser.preferences) || {})
const params = querystring.parse(window.location.search.substring(1))
const defaultDismissed = preferences.get('planner-onboarding-dismissed', false) && !params.onboarding

const messages = defineMessages({
  title: {
    id: 'PlannerOnboardingModal.title',
    defaultMessage: 'Welcome to the Route Planner'
  }
})

export const PlannerOnboardingModal = props => {
  const fm = useFormatMessage()
  const [activeTip, setActiveTip] = useState(0)
  const [dismissed, setDismissed] = useState(defaultDismissed)

  const onRequestClose = () => {
    fetchJSON('/set_preference.json', { key: 'planner-onboarding-dismissed', value: true })
    setDismissed(true)
  }

  const nextClicked = () => {
    setActiveTip((activeTip + 1) % tips.length)
  }

  if (dismissed) {
    return null
  }

  const tip = tips[activeTip]
  const title = titles[tip.key]
  const description = descriptions[tip.key]

  const button = (activeTip >= tips.length - 1)
    ? (
      <div>
        <CTA link inline margins={false} onClick={() => setActiveTip(0)}><T id='PlannerOnboardingModal.showMeAgain' defaultMessage='Show me again' /></CTA>
        <CTA inline margins={false} onClick={onRequestClose}><Msg capitalized m={commonCTAs.done} /></CTA>
      </div>
    ) : (
      <CTA margins={false} inline onClick={nextClicked}><Msg capitalized m={commonCTAs.next} /></CTA>
    )

  const pips = tips.map((tip, index) => (
    <span className={cx(styles.pip, activeTip === index && styles.current)} onClick={() => setActiveTip(index)} key={tip.gif} />
  ))

  return (
    <ModalOverlay
      className={styles.PlannerOnboardingModal}
      maxWidth='800px'
      shouldCloseOnOverlayClick
      title={fm(messages.title)}
      onRequestClose={onRequestClose}
      footer={<div className={styles.ctaContainer}>{button}</div>}
      theme={blueTheme}>
      <div className={styles.TipsCarousel}>
        <div className={styles.imgContainer}>
          <img src={tip.gif} />
        </div>
        <p className={styles.title}><Msg m={title} /></p>
        <p className={introText}><T {...description} values={descriptionsValues} /></p>
        <div>{pips}</div>
      </div>
    </ModalOverlay>
  )
}
